module.exports = __webpack_public_path__ + "img/acuario_michin.ebef88f7.png";